export default class UserPageEditor {
  constructor(options) {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click"

    document.getElementById('edit-title').addEventListener(action, this.showTitleEdit.bind(this))
  }

  showTitleEdit(event) {
    event.preventDefault()
    document.getElementById('title').classList.add("hidden")
    document.getElementById('title-form').classList.remove("hidden")
  }
}
